import { Spinner, Table, Button } from "react-bootstrap";

function formatCurrency(value) {
  const amount = Number(value) || 0;
  return amount.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export default function HonorariosTable({
  isFetching,
  honorarios,
  onEdit,
  onDelete,
  isDeleting,
}) {
  if (isFetching) {
    return (
      <div className="d-flex justify-content-center m-5">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  if (!honorarios?.length) {
    return (
      <p className="text-muted mb-0">Nenhum honorário cadastrado.</p>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Tipo</th>
            <th>Contratado</th>
            <th>Recebido</th>
            <th>Saldo</th>
            <th style={{ width: 120 }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {honorarios.map((honorario) => {
            const contracted = Number(honorario.contracted_value) || 0;
            const received = Number(honorario.received_value) || 0;
            const saldo =
              honorario.saldo != null
                ? Number(honorario.saldo)
                : contracted - received;

            return (
              <tr key={honorario.id}>
                <td>{honorario.client || "—"}</td>
                <td>{honorario.type || "—"}</td>
                <td>{formatCurrency(contracted)}</td>
                <td>{formatCurrency(received)}</td>
                <td>{formatCurrency(saldo)}</td>
                <td>
                  <div className="d-flex gap-1 flex-wrap">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      title="Editar"
                      onClick={() => onEdit?.(honorario)}
                    >
                      <i className="bi bi-pencil" />
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      title="Excluir"
                      disabled={isDeleting}
                      onClick={() => onDelete?.(honorario)}
                    >
                      <i className="bi bi-trash" />
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}
